import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Lenis from '@studio-freight/lenis';
import InitialNav from '../../components/InitialNav';
import Footer from '../../components/Footer';
import image from '../../assets/images/header image.png'; 
import image3 from '../../assets/images/teacher-avatar.png'; 
import image4 from '../../assets/images/About us page-cuate 1.png'; 
import "./LandingPage.css";
import icon1 from "../../assets/icons/objective1.png";
import icon2 from "../../assets/icons/objective2.png";
import icon3 from "../../assets/icons/objective3.png";
import icon4 from "../../assets/icons/objective4.png";
import image2 from '../../assets/images/Settings-bro 1.png';
import icon5 from "../../assets/icons/mdi_tick-circle.png";
import { Element } from 'react-scroll';

const LandingPage = () => {
  // Initialize Lenis for smooth scrolling
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2, // Smooth scroll duration
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Easing function
      smooth: true, // Enable smooth scrolling
    });

    // RAF (Request Animation Frame) for smooth scroll
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Cleanup Lenis on unmount
    return () => {
      lenis.destroy();
    };
  }, []);

  // Animation variants
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  const fadeInLeft = {
    initial: { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.6 },
  };

  const fadeInRight = {
    initial: { opacity: 0, x: 20 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.6 },
  };

  return (
    <div>
      <InitialNav />
      
      {/* get started part */}
      <Element name='getStarted' className='element'>
        <motion.div {...fadeInUp} className='container-getStarted'>
          <div className='container-getStarted-half'>
            <div className='container-getStarted-half-heading'>
              <h1>Start <span style={{ color: '#FABC2A' }}>Learning</span></h1>
              <h1>From The Best</h1>
              <h1>Platform</h1>
            </div>
            <div className='container-getStarted-half-des'>
              <p>SpeakSail is an English learning platform dedicated to primary school students. With various activities focusing on the four language skills, to help enhance their communication skills on English.</p>
            </div>
            <div className='container-getStarted-half-button'>
              <Link to='/login/student'>Get Started</Link>
            </div>
          </div>
          <div className='container-getStarted-half'>
            <motion.img src={image} alt='' width={600} height={400} {...fadeInRight} />
          </div>
        </motion.div>
      </Element>
      
      {/* objective part */}
      <Element name='objective' className='element'>
        <motion.div {...fadeInUp} className='container-objective'>
          <div className='container-objective-heading'><h1>Our <span style={{ color: '#FABC2A' }}>Objective</span></h1></div>
          <div className='container-objective-points'>
            {[
              { icon: icon1, text: 'To improve the oral English communication of Bangladeshi students' },
              { icon: icon2, text: 'To enhance English language learning, focusing on listening and speaking skills' },
              { icon: icon3, text: 'To assist students to prepare for real-life situations where English communication is inevitable in this era of globalisation.' },
              { icon: icon4, text: 'To cater the needs of students who require further input about learning beyond classroom.' },
            ].map((item, index) => (
              <motion.div key={index} {...fadeInLeft} className='container-objective-points-indv'>
                <img src={item.icon} alt='' width={40} height={40} />
                <div><p>{item.text}</p></div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </Element>

      {/* part: what we offer */}
      <Element name='what-we-offer' className='element'>
        <motion.div {...fadeInUp} className='container-offer'>
          <div className='container-offer-heading'><h1>What <span style={{color: '#FABC2A'}}>We Offer</span></h1></div>
          <div className='container-offer-half'>
            <div className='container-offer-left'>
              <motion.img src={image2} alt='' width={480} height={340} {...fadeInLeft} />
            </div>
            <div className='container-offer-right'>
              {[
                { icon: icon5, title: 'Customized lessons in all four language skills', description: 'Reading, Writing, Listening and Speaking.' },
                { icon: icon5, title: 'Daily Missions', description: 'Providing daily missions keep students motivated and learn more.' },
                { icon: icon5, title: 'Practice exercises', description: 'Reading, Writing, Listening and Speaking.' },
                { icon: icon5, title: 'Vocab Treasure', description: 'New words daily to maintain their rich vocabulary.' },
              ].map((item, index) => (
                <motion.div key={index} {...fadeInRight} className='container-offer-right-point'>
                  <img src={item.icon} alt='' width={30} height={30} />
                  <div>
                    <p style={{fontWeight:'600'}}>{item.title}</p>
                    <p>{item.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </Element>

      {/* Tools for teachers and learners */}
      <Element name='tools' className='element'>
        <motion.div {...fadeInUp} className='container-tools'>
          <div className='container-tools-left'>
            <div>
              <h1><span style={{color:'#FABC2A'}}>Tools</span> for Teachers</h1>
              <h1>and Learners</h1>
            </div>
            <div>
              <p>Class has a dynamic set of teaching tools built to be deployed and used during class. Teachers can handout assignments in real-time for students to complete and submit their work.</p>
            </div>
          </div>
          <div className='container-tools-right'>
            <motion.img src={image3} alt='' width={600} height={400} {...fadeInRight} />
          </div>
        </motion.div>
      </Element>
      
      {/* About Us */}
      <Element name='about-us' className='element'>
        <motion.div {...fadeInUp} className='container-aboutUs'>
          <div className='container-aboutUs-heading'><h1>About <span style={{color:'#FABC2A'}}>Us</span></h1></div>
          <div className='container-aboutUs-half'>
            <div className='container-aboutUs-left'>
              <motion.img src={image4} alt='' width={600} height={400} {...fadeInLeft} />
            </div>
            <div className='container-aboutUs-right'>
              <p>Welcome to <span style={{color:"#FABC2A"}}>SpeakSail</span>, where we are focused in filling the gap of the evident oral English communication issue targeting the primary (class 1 to class 5) level students. Even though English plays a major role in global communication, Bangladesh is yet to form a bridge to join this globalization, in respect to the lack of effective oral English communication. Keeping these issues in mind, we have introduced a system that will be focused on the aspects of speaking and listening to promote better communication.</p>
            </div>
          </div>
        </motion.div>
      </Element>
      
      <Footer />
    </div>
  );
}

export default LandingPage;